export default class ErrorOr<T> {
    data: T | null;
    isSuccess: boolean;
    isFailure: boolean;
    exception: Error | null;

    private constructor(isSuccess: boolean, data: T | null, exception: Error | null) {
        this.data = data;
        this.isSuccess = isSuccess;
        this.isFailure = !isSuccess;
        this.exception = exception;
    };

    public static Success<T>(data: T) {
        if(data === null || data === undefined) {
            throw new Error("Data cannot be null");
        }
        return new ErrorOr<T>(true, data, null)
    }

    public static Failed<T>(error: Error) {
        if(error === null || error === undefined) {
            throw new Error("Exception cannot be null");
        }
        return new ErrorOr<T>(false, null, error)
    }
}